var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('SignUpForm',{on:{"signUp":_vm.signup,"signInHereButton":_vm.signInHereButton}}),_c('SnackbarNotifier',{attrs:{"isShow":_vm.isShowSnackBar,"message":_vm.responseMessage,"snackType":_vm.snackbarType,"colour":_vm.snackBarColour},on:{"eReset":_vm.resetSnackBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }